// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@charset \"UTF-8\";\n.clickable[data-v-57a669e2] {\n  color: #409EFF;\n  cursor: pointer;\n}\n\n/* 表头字段提示样式 */\n.header-field-container[data-v-57a669e2] {\n  display: flex;\n  align-items: center;\n}\n.header-info-icon[data-v-57a669e2] {\n  margin-left: 0.25rem;\n  font-size: 0.875rem;\n  vertical-align: middle;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
